let loaderPromise: Promise<typeof window.google> | null = null;
const CALLBACK_NAME = "__gaggMapsInit";

declare global {
  interface Window {
    __gaggMapsInit?: () => void;
  }
}

export async function loadGoogleMapsApi(apiKey: string): Promise<typeof window.google> {
  const mapsNamespace = window.google?.maps as
    | (typeof window.google.maps & { importLibrary?: unknown })
    | undefined;

  if (
    typeof mapsNamespace?.importLibrary === "function" ||
    typeof mapsNamespace?.Map === "function"
  ) {
    return window.google;
  }

  if (!loaderPromise) {
    loaderPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector<HTMLScriptElement>(
        "script[data-google-maps-loader='true']",
      );

      if (existing) {
        window[CALLBACK_NAME] = () => resolve(window.google);
        existing.addEventListener("error", () => reject(new Error("Google Maps failed to load.")), {
          once: true,
        });
        return;
      }

      const script = document.createElement("script");
      script.async = true;
      script.defer = true;
      script.dataset.googleMapsLoader = "true";
      window[CALLBACK_NAME] = () => {
        if (window.google?.maps) {
          resolve(window.google);
          return;
        }

        reject(new Error("Google Maps loaded without the Maps namespace."));
      };
      script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(
        apiKey,
      )}&loading=async&v=weekly&libraries=places&callback=${encodeURIComponent(CALLBACK_NAME)}`;
      script.addEventListener("error", () => reject(new Error("Google Maps failed to load.")));
      document.head.append(script);
    });
  }

  return loaderPromise;
}
